export default {"src":"/_next/static/media/Arrow1.f657ab43.svg","height":230,"width":116,"blurWidth":0,"blurHeight":0};